export default "__VITE_ASSET__BvNtXBu6__"